<template>
  <div class="flex items-center space-x-2">
    <span :class="isValid ? 'valid' : 'invalid'">{{ isValid ? '✔' : '✘' }}</span>
    <span :class="isValid ? 'valid' : 'invalid'">{{ text }}</span>  </div>
</template>

<script>
export default {
  name: "ChecklistItem",
  props: {
    text: String,
    isValid: Boolean
  }
};
</script>

<style scoped>
.checklist-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}
</style>